import { FormattedMessage } from 'react-intl';
import React from 'react';
import './radioButton.scss';
import { uuidv4 } from '../../../utils/utility';
const RadioButton = ({
  tabIndex,
  name = '',
  label = '',
  checked = false,
  value = '',
  parentInputClassName = '',
  inputClassName = '',
  style = {},
  isLocalization = true,
  width = '25px',
  height = '25px',
  theme = 'light',
  onChange = () => {},
}) => {
  const id = uuidv4();
  // about theme
  let checkedClass = '';
  if (checked) {
    checkedClass = 'radioInputChecked';
  }
  // about theme
  return (
    <div className={`${parentInputClassName}`}>
      <div className="radio">
        <div className={`d-flex flex-wrap input-radioButton-${theme}-mode`}>
          <input
            className="radioInput d-none"
            type="radio"
            id={id}
            value={value}
            name={name}
            onChange={onChange}
            checked={checked}
          />
          <label
            className={`radioButtonLabel cursor-pointer d-flex align-items-center removeOutline ${checkedClass} ${
              inputClassName && inputClassName
            }`}
            tabIndex={tabIndex}
            style={style}
            htmlFor={id}
            onKeyPress={(e) => {
              if (e.key === 'Enter') e.target.click();
            }}
          >
            <span
              className="radioButtonspan d-inline-block rounded-circle"
              style={{ width: width, height: height }}
            />
            {isLocalization ? (
              <span className="text-start text-third mx-2">
                <FormattedMessage id={label} defauleMessafe={label} />
              </span>
            ) : (
              <span className="text-start text-third mx-2">{label}</span>
            )}
          </label>
        </div>
      </div>
    </div>
  );
};
export default RadioButton;
